module.exports = __webpack_public_path__ + "src/img/artist/work01_2.jpg?8164a21a5661c9cb4cd2e5d436f6dbe2";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work01_2.jpg
// module id = 18
// module chunks = 0